import { Box } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { getMessageColorSchema } from 'components'
import { Message } from 'lib/apiClient'
import { MessageDate, TextMessage } from 'components/ChatMessage/components'

import { DebugChatMessageLayout } from './DebugChatMessageLayout'

interface SimpleDebugChatMessageProps {
  message: Message
  isSelected?: boolean
  onClick?: () => void
}

export const SimpleDebugChatMessage: FC<SimpleDebugChatMessageProps> = ({
  message,
  onClick,
  isSelected,
}) => {
  const colorSchema = getMessageColorSchema({
    messageType: message.authorRole,
    isDebugView: true,
  })

  return (
    <DebugChatMessageLayout
      message={message}
      colorSchema={colorSchema}
      onClick={onClick}
      isSelected={isSelected}
    >
      <Box px="s-16" pt="s-8" pb="s-6" display="inline-table">
        <TextMessage text={message.text} colorSchema={colorSchema} />
        <MessageDate createdAt={message.created} colorSchema={colorSchema} />
      </Box>
    </DebugChatMessageLayout>
  )
}
